import React, { useContext, useState } from "react";
import ModulesContext from "../Module/ModulesContext";
import Avatar from "components/common_components/Avatar";
import Icon from "components/common_components/Icon";
import { dateToString } from "utils/dateUtils";

function ClientInfoView({ client, balance }) {
    const [showProfileContent, setShowProfileContent] = useState(false);

    const toggleProfile = () => {
        setShowProfileContent((prev) => !prev);
    };

    const { clientPhoto } = useContext(ModulesContext);

    function renderPhoto() {
        const { firstName, middleName, lastName } = client;
        const name = (firstName || "") + (middleName || "") + (lastName || "");
        return <Avatar src={clientPhoto} name={name} />;
    }

    return (
        <div className="profile">
            <div className="profile__header">
                {renderPhoto()}

                <div className="profile__title">
                    <div>
                        <strong>
                            {client.firstName} {client.lastName}
                        </strong>
                    </div>
                    <div className="font-small">
                        Balance: <strong className="text--primary">{balance}</strong>
                    </div>
                </div>

                <div className="profile__btn" onClick={toggleProfile}>
                    <Icon name={showProfileContent ? "caret-up" : "caret-down"} size="xs" color="primary" />
                </div>
            </div>
            {showProfileContent && (
                <div className="profile__content">
                    <div className="profile__section">
                        <div className="profile__item">
                            <span className="profile__label">Email:</span>
                            {client.email}
                        </div>

                        <div className="profile__item">
                            <span className="profile__label">Birth:</span>
                            {dateToString(client.birthDate, false)}, {client.birthPlace}
                        </div>

                        <div className="profile__item">
                            <span className="profile__label">Address:</span>
                            {client.address}
                        </div>

                        <div className="profile__item">
                            <span className="profile__label">City:</span>
                            <span>
                                {client.city} {client.state}, <strong>{client.country.name}</strong>
                            </span>
                        </div>
                    </div>

                    <div className="profile__section">
                        <div className="profile__item">
                            <span className="profile__label">Zip code:</span>
                            {client.zipCode}
                        </div>
                        <div className="profile__item">
                            <span className="profile__label">Home phone:</span>
                            {client.homePhone}
                        </div>
                        <div className="profile__item">
                            <span className="profile__label">Work phone:</span>
                            {client.workPhone}
                        </div>
                    </div>

                    <div className="profile__section">
                        <div className="profile__item">
                            <span className="profile__label">Referred by:</span>
                            <div>
                                <strong>{client.referredBy}</strong>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default ClientInfoView;
